import React from 'react';
import Error from './Error';
import './styles.scss';

export default function CallUs() {
    return (
        <Error headerTxt="We're Sorry">
            <p>You indicated that the policy displayed is not associated to your account.</p>
        </Error>
    );
}
